import { NgModule } from '@angular/core';
import { PortalUserAreaLayoutComponent } from './user-area-layout.component';
import { RouterModule } from '@angular/router';
import { PortalUserAreaFooterComponent } from './partials/footer/footer.component';
import { PortalUserAreaHeaderComponent } from './partials/header/header.component';
import { PortalUserAreaSidebarComponent } from './partials/sidebar/sidebar.component';
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { CommonModule } from '@angular/common';
import { PortalUserAreaUserStatusComponent } from './partials/user-status/user-status.component';
import { ClientStatusComponent } from './partials/client-status/client-status.component';
import { ThemeStatusComponent } from './partials/theme-status/theme-status.component';
import { BreadCrumbComponent } from './partials/bread-crumb/bread-crumb.component';
// import { NotFoundComponent } from '../../partials/not-found/not-found.component';
import { InfrastructureModule } from '../../../../../infra/infrastructure.module';

@NgModule({
  declarations: [
    PortalUserAreaLayoutComponent,
    PortalUserAreaHeaderComponent,
    PortalUserAreaFooterComponent,
    PortalUserAreaUserStatusComponent,
    ClientStatusComponent,
    ThemeStatusComponent,
    BreadCrumbComponent,
    PortalUserAreaSidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PanelBarModule,
    InfrastructureModule
  ],
  exports: []
})
export class PortalUserAreaLayoutModule { }
